import React from 'react';
import PropTypes from 'prop-types';
import ExternalLink from 'components/Widgets/ExternalLink';

export default function SummaryDownload({ plan }) {
  return (
    <section>
      <h2>Terms and Conditions</h2>
      <div className="d-flex justify-content-between mb-3">
        <p>
          Click Download to save your policy on your device.
          <span className="text-primary ms-5">
            Accepted on
            {' '}
            {plan.attributes.activated_date_formatted}
          </span>
        </p>
        <ExternalLink
          href={plan.attributes.report}
        >
          Download
        </ExternalLink>
      </div>
    </section>
  );
}

SummaryDownload.propTypes = {
  plan: PropTypes.object.isRequired,
};
